import { createContext, SetStateAction, Dispatch } from 'react';
import { Nullable } from '../../utilities/common_types';

interface PreferredLanguage {
  language: Nullable<string>;
  setLanguage: Dispatch<SetStateAction<Nullable<string>>>;
}
export const PreferredLanguageContext = createContext<PreferredLanguage>({
  language: null,
  setLanguage: () => null,
});
